import { Enum } from './Enum';

export class MemberContactRankingType extends Enum {
  translationKey = 'memberContactRankingType';

  static readonly asArray: MemberContactRankingType[] = [];

  static readonly byKey: { [name: string]: MemberContactRankingType } = {};

  static readonly MEMBER = new MemberContactRankingType('MEMBER');

  static readonly CARE_TEAM_MEMBER = new MemberContactRankingType(
    'CARE_TEAM_MEMBER',
  );

  constructor(public readonly value: string) {
    super();
    MemberContactRankingType.asArray.push(this);
    MemberContactRankingType.byKey[value] = this;
  }
}

export default MemberContactRankingType;
